module.exports = __webpack_public_path__ + "img/logo.4eca04c0.png";